import { render, staticRenderFns } from "./center-home.vue?vue&type=template&id=1653bbee&scoped=true&"
import script from "./center-home.vue?vue&type=script&lang=js&"
export * from "./center-home.vue?vue&type=script&lang=js&"
import style0 from "./center-home.vue?vue&type=style&index=0&id=1653bbee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1653bbee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1653bbee')) {
      api.createRecord('1653bbee', component.options)
    } else {
      api.reload('1653bbee', component.options)
    }
    module.hot.accept("./center-home.vue?vue&type=template&id=1653bbee&scoped=true&", function () {
      api.rerender('1653bbee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/realTime/comp/center-home.vue"
export default component.exports